"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileService = void 0;
const api_1 = require("./api");
const PATH = '/profile/api/profiles';
const PATH_V1 = '/profile/api/v1/profiles';
const PATH_V2 = '/profile/api/v2/profiles';
class ProfileService {
    static async getProfile() {
        try {
            return await api_1.API.get({
                url: `${PATH}/me`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getProfileV2() {
        try {
            return await api_1.API.get({
                url: `${PATH_V2}/me`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async updateProfile(data) {
        try {
            return await api_1.API.put({
                url: `${PATH}`,
                body: data
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async updateProfileV1(data) {
        try {
            return await api_1.API.put({
                url: `${PATH_V1}`,
                body: data
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async socialConnect(provider, data) {
        try {
            return await api_1.API.post({
                url: `${PATH}/social-connect/${provider}`,
                body: data
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getLoyaltySummary() {
        try {
            return await api_1.API.get({
                url: `${PATH}/loyalty-summary`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async deleteAccount() {
        try {
            return await api_1.API.delete({
                url: `${PATH_V2}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async verifyId(data) {
        return api_1.API.put({
            url: `${PATH}/verifyId`,
            body: data
        });
    }
    static async verifyStatus() {
        return api_1.API.put({
            url: `${PATH}/verifyId/status`
        });
    }
    static async renewIdologyUrl() {
        try {
            return await api_1.API.get({
                url: `${PATH}/verifyIdUrl`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async updateProfileV2(data) {
        try {
            return await api_1.API.put({
                url: `${PATH_V2}`,
                body: data
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async fetchTermsAndConditions() {
        try {
            return await api_1.API.get({
                url: `/profile/api/terms-and-conditions`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async updateTermsAndConditions() {
        try {
            return await api_1.API.post({
                url: `/profile/api/terms-and-conditions`
            });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.ProfileService = ProfileService;
//# sourceMappingURL=profile-service.js.map